var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItem), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.children.length > 0) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": '../../../..' + item.url,
        "icon": item.icons
      }
    }, [_vm._l((item.children), function(child) {
      return [_c('SidebarNavLink', {
        attrs: {
          "name": child.name,
          "url": '../../../..' + child.url,
          "icon": child.icons
        }
      })]
    })], 2)] : [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "icon": item.icons,
        "url": '../../../..' + item.url
      }
    })]], 2)
  }), 0), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acf8546","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 514
// module chunks = 2